import * as React from 'react';
import { Control, useController } from 'react-hook-form';
import { CmdError } from '@commander-services/gui-components';
import TooltipComponent from '../../TooltipComponent';

export interface ICheckboxGroupOption {
  item: string;
  value: string;
  disabled?: boolean;
  notHidden?: boolean;
}

interface ICheckboxInputProps {
  label: string;
  name: string;
  id: string;
  options: ICheckboxGroupOption[];
  control: Control<any>;
  required?: boolean;
  // rowOrRows?: string;
  // className?: string;
  // newStyle?: boolean;
  onChangeCallback?: (value: string[]) => void;
  tooltip?: string;
  noGrid?: boolean;
  gridTemplateColumns?: string;
  bossCheckbox?: string;
  disabled?: boolean;
  isChangeDetail?: { [key: string]: string };
  fullOpacity?: boolean;
}

export default function CheckboxGroupHookForm(props: ICheckboxInputProps): JSX.Element {
  const [selectedItems, setSelectedItems] = React.useState<string[]>([]);

  const {
    field: { ref, onChange, onBlur, value },
    fieldState: { invalid, error },
  } = useController({
    name: props.name,
    control: props.control,
    defaultValue: [], // or the default value
  });

  React.useEffect(() => {
    // semi checkbox
    const checkbox: any = document.getElementById('checkboxGroupCheckboxIndeterminate');
    if (checkbox) {
      const disabledOptions =
        props.options && props.options.length > 0
          ? props.options.filter((i: any) => i.disabled)
          : [];
      const disabledItems =
        disabledOptions && disabledOptions.length > 0
          ? disabledOptions.map((j: any) => {
              return String(j.value);
            })
          : [];
      const filteredSelectedItems =
        selectedItems && selectedItems.length > 0
          ? selectedItems.filter((item: string) => !disabledItems.includes(item))
          : [];
      if (filteredSelectedItems.length === 0) {
        checkbox.indeterminate = false;
        checkbox.checked = false;
      } else if (props.options.length === selectedItems.length) {
        checkbox.indeterminate = false;
        checkbox.checked = true;
      } else {
        checkbox.indeterminate = true;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.options.length, selectedItems.length, value]);

  React.useEffect(() => {
    if (value) {
      setSelectedItems(value);
    }
  }, [value]);

  const handleAllChoose = (e: any) => {
    if (e.target.checked) {
      const optionItems = props.options.map((item: any) => {
        return String(item.value);
      });
      setSelectedItems(optionItems);
      onChange(props.name, optionItems);
    } else {
      const disabledOptions = props.options.filter((i: any) => i.disabled);
      const disabledItems = disabledOptions.map((j: any) => {
        return String(j.value);
      });
      setSelectedItems(disabledItems);
      onChange(props.name, disabledItems);
    }
  };

  // const handleOnChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   event.preventDefault();
  //   const dataValue = event.currentTarget.value;
  //   if (dataValue) {
  //     if (selectedItems.includes(dataValue)) {
  //       const newSelectedItems: string[] = [];
  //       selectedItems.forEach((item: string) => {
  //         if (item !== dataValue) {
  //           newSelectedItems.push(item);
  //         }
  //       });
  //       setSelectedItems(newSelectedItems);
  //       setFieldValue(props.name, newSelectedItems);
  //     } else {
  //       const newArrAfterAdd = selectedItems;
  //       newArrAfterAdd.push(dataValue);
  //       setSelectedItems(newArrAfterAdd);
  //       setFieldValue(props.name, newArrAfterAdd);
  //     }
  //   }
  // };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const dataValue = event.currentTarget.getAttribute('data-value');
    const disabled = event.currentTarget.getAttribute('data-disabled');
    if (disabled === 'true') {
      return;
    }
    if (dataValue) {
      if (selectedItems.includes(dataValue)) {
        const newSelectedItems: string[] = [];
        selectedItems.forEach((item: string) => {
          if (item !== dataValue) {
            newSelectedItems.push(item);
          }
        });
        setSelectedItems(newSelectedItems);
        onChange(props.name, newSelectedItems);
        if (props.onChangeCallback) {
          props.onChangeCallback(newSelectedItems);
        }
      } else {
        const newArrAfterAdd = selectedItems;
        newArrAfterAdd.push(dataValue);
        setSelectedItems(newArrAfterAdd);
        onChange(props.name, newArrAfterAdd);
        if (props.onChangeCallback) {
          props.onChangeCallback(newArrAfterAdd);
        }
      }
    }
  };

  return (
    <div className={`checkbox-group-component form-group ${error && 'form-group-error'}`}>
      <div>
        {(props.label || props.id === 'notifications') && (
          <label className="d-block form-label" style={{ paddingRight: '23px' }}>
            {props.required && <span className="text-danger required-field-info">*</span>}
            {props.label}
          </label>
        )}
        <div className="d-block" style={{ marginBottom: '-20px' }}>
          {props.bossCheckbox && [
            <div style={{ marginTop: '5px', paddingBottom: '10px' }}>
              <div
                className="e-checkbox"
                style={{
                  padding: '0 4px 4px 0',
                }}
              >
                <label>
                  <input
                    onChange={handleAllChoose}
                    type="checkbox"
                    className="js-checkbox-indeterminate"
                    id="checkboxGroupCheckboxIndeterminate"
                    data-cy={`checkboxGroup-${props.name}`}
                  />
                  <span
                    style={{
                      fontSize: '13px',
                      fontFamily: 'Open Sans, sans-serif',
                    }}
                  >
                    {props.bossCheckbox}
                  </span>
                </label>
              </div>
            </div>,
            <hr style={{ color: '#ccc', marginBottom: '16px', marginTop: '15px' }} />,
          ]}
          <div className="row">
            <div
              className="col-auto"
              title={props.tooltip || ''}
              style={{
                display: props.noGrid ? '' : 'grid',
                gridTemplateRows: 'repeat(2, max-content)',
                gridTemplateColumns: props.gridTemplateColumns || ' 1fr 1fr 1fr ',
                width: '100%',
              }}
            >
              {props.options.length ? (
                props.options.map((option: ICheckboxGroupOption, index: number) => (
                  <div
                    className="e-checkbox"
                    key={`checkbox-${props.name}-${index}`}
                    style={{
                      marginLeft: props.label || props.id === 'notifications' ? 0 : '40px',
                      marginRight: '32px',
                      display: props.noGrid ? 'block' : '',
                      marginBottom: props.noGrid ? '15px' : '0',
                      padding: '0 0px 8px 0',
                    }}
                  >
                    {' '}
                    {props.isChangeDetail && props.isChangeDetail[option.value] ? (
                      <TooltipComponent
                        id={props.id}
                        firstItems={true}
                        width="180px"
                        positionLeft={true}
                        overlay={
                          <div style={{ color: '#fff' }}>{props.isChangeDetail[option.value]}</div>
                        }
                      >
                        <label data-cy={`multipleCheckboxes-${option.value}`}>
                          <div
                            style={{
                              background: 'rgb(61, 114, 200)',
                              position: 'absolute',
                              width: '25px',
                              height: '22px',
                              zIndex: 1,
                              opacity: 0.3,
                              borderRadius: '8px',
                              left: '-5px',
                              top: '-2px',
                            }}
                          />
                          <input
                            type="checkbox"
                            disabled={true}
                            value={option.value}
                            onChange={handleOnChange}
                            data-cy={`checkboxGroup-${props.name}-${option.value}`}
                            checked={
                              selectedItems &&
                              selectedItems.length > 0 &&
                              selectedItems.includes(String(option.value)) &&
                              (!option.disabled || option.notHidden)
                            }
                            data-value={option.value}
                            data-disabled={option.disabled}
                            className="change-detail"
                          />
                          <span
                            style={{
                              fontSize: '13px',
                              fontFamily: 'Open Sans, sans-serif',
                            }}
                          >
                            {option.item}
                          </span>
                        </label>
                      </TooltipComponent>
                    ) : (
                      <label data-cy={`multipleCheckboxes-${option.value}`}>
                        <input
                          type="checkbox"
                          disabled={props.disabled || option.disabled || false}
                          value={option.value}
                          onChange={handleOnChange}
                          data-cy={`checkboxGroup-${props.name}-${option.value}`}
                          checked={
                            selectedItems &&
                            selectedItems.length > 0 &&
                            selectedItems.includes(String(option.value)) &&
                            (!option.disabled || option.notHidden)
                          }
                          data-value={option.value}
                          data-disabled={option.disabled}
                          className={props.fullOpacity ? 'change-detail' : ''}
                        />
                        <span
                          style={{
                            fontSize: '13px',
                            fontFamily: 'Open Sans, sans-serif',
                          }}
                        >
                          {option.item}
                        </span>
                      </label>
                    )}
                  </div>
                ))
              ) : (
                <div />
              )}
            </div>
          </div>{' '}
          <br />
          {error && <CmdError message={error.message} />}
        </div>
      </div>
    </div>
  );
}
